import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import API from "../../../API";
import CRUDTable from "../../../Shared/CRUDTable";
import * as validationSchemas from "../../../validationSchemas";

import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { Col, Row } from "react-bootstrap";
import jsPDF from "jspdf";
import { API_URL } from "../../../../constants";

const validationSchema = Yup.object({
  name: validationSchemas.readableText.label("Name").required(),
  age: validationSchemas.readableText.label("Age").required(),
  gender: validationSchemas.readableText.label("Gender").required(),
  mobileno: validationSchemas.readableText.label("Mobileno").required(),
});

const ProgramQuestions = () => {
  const [showPopup, setShowPopup] = useState(false);
  // const [step, setStep] = useState(0);
  const [steps, setSteps] = useState([1]);   // all visible questions

  const [recommendation, setRecommendation] = useState("");
  const [answer, setAnswer] = useState({});
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [isRerenderOnData, setIsRerenderOnData] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    age: "",
    gender: "",
    mobileno: "",
  });

  useEffect(() => {
        fetch(API_URL + "programquestion/program")
      .then((res) => res.json())
      .then((data) => {
        const formatted = data.map((q) => ({
          ...q,
          q_id: Number(q.q_id),
        }));
        setQuestions(formatted);
        //setStep(1);
      })
      .catch((err) => console.error(err));
  }, []);

  const handleShow = () => setShowPopup(true);

  const handleClose = () => {
    setShowPopup(false);
    setSteps([0]);
    setRecommendation("");
    setAnswer({});
    setFormData({
      name: "",
      age: "",
      gender: "",
      mobileno: "",
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    if (
      !formData.name ||
      !formData.age ||
      !formData.gender ||
      !formData.mobileno
    ) {
      alert("Please fill all fields");
      return;
    }

   // setStep([1]);
  };

  // const handleAnswer1 = (value) => {
  //   setAnswer((prev) => ({ ...prev, [step]: value }));

  //   switch (step) {
  //     case 1:
  //       setStep(value === "YES" ? 7 : 2);
  //       break;

  //     case 2:
  //       setStep(value === "YES" ? 3 : 4);
  //       break;

  //     case 3:
  //       if (value === "YES") {
  //         setRecommendation("Clinical Hair Loss Control Program");
  //       } else {
  //         setStep(4);
  //       }
  //       break;

  //     case 4:
  //       if (value === "YES") {
  //         setStep(5);
  //       } else {
  //         setRecommendation("Clinical Hair Loss Control Program");
  //       }
  //       break;

  //     case 5:
  //       if (value === "YES") {
  //         setRecommendation("Advanced Hair Restoration Protocol");
  //       } else {
  //         setStep(6);
  //       }
  //       break;

  //     case 6:
  //       setRecommendation("Clinical Hair Recovery Program");
  //       break;

  //     case 7:
  //       setStep(value === "YES" ? 8 : 9);
  //       break;

  //     case 8:
  //       if (value === "YES") {
  //         setStep(9);
  //       } else {
  //         setRecommendation(
  //           "Advanced Hair Restoration Protocol (Stabilise first)"
  //         );
  //       }
  //       break;

  //     case 9:
  //       if (value === "YES") {
  //         setStep(10);
  //       } else {
  //         setRecommendation("Transplant not advised now");
  //       }
  //       break;

  //     case 10:
  //       if (formData.gender.toLowerCase() === "male") {
  //         setRecommendation("Male QHT FUE Hair Transplant");
  //       } else {
  //         setStep(11);
  //       }
  //       break;

  //     case 11:
  //       if (value === "YES") {
  //         setRecommendation("Female transplant usually not advised");
  //       } else {
  //         setRecommendation("Female QHT FUE Hair Transplant");
  //       }
  //       break;

  //     default:
  //       break;
  //   }
  // };

   // ---------- Validation ----------
  const validateForm = () => {
    const newErrors = {};

    if (!formData.name || formData.name.trim() === "") {
      newErrors.name = "Please enter a valid name";
    }

    if (!formData.age || isNaN(formData.age) || formData.age <= 0) {
      newErrors.age = "Please enter a valid age";
    }

    if (!formData.gender) {
      newErrors.gender = "Please select gender";
    }

    if (
      !formData.mobileno ||
      !/^\d{10}$/.test(formData.mobileno.replace(/\D/g, ""))
    ) {
      newErrors.mobileno = "Enter valid 10 digit mobile number";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    try {
      setLoading(true);

      // if (!formData.name || formData.name.trim() === "") {
      //   alert("Please enter a valid name");
      //   setLoading(false);
      //   return;
      // }

      // if (!formData.age || isNaN(formData.age) || formData.age <= 0) {
      //   alert("Please enter a valid age");
      //   setLoading(false);
      //   return;
      // }

      // if (!formData.gender || formData.gender.trim() === "") {
      //   alert("Please select a gender");
      //   setLoading(false);
      //   return;
      // }

      // if (!formData.mobileno || !/^\d{10}$/.test(formData.mobileno.replace(/\D/g, ""))) {
      //   alert("Please enter a valid 10-digit mobile number");
      //   setLoading(false);
      //   return;
      // }
       e.preventDefault();
    if (!validateForm()) return;
      const response = await fetch(
        API_URL + "programquestion/answer",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ...formData,
            answer,
            recommendation,
          }),
        }
      );

      if (response.ok) {
        alert("Saved Successfully");
        //generatePDF();
        generatePremiumPDF();
       // handleClose();
      } else {
        alert("Failed to save");
      }
    } catch (error) {
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };
const getNextStep1 = (step, value, formData) => {
  switch (step) {
    case 1:
      return value === "YES" ? 7 : 2;

    case 2:
      return value === "YES" ? 3 : 4;

    case 3:
      return value === "YES" ? "Clinical Hair Loss Control Program" : 4;

    case 4:
      return value === "YES" ? 5 : "Clinical Hair Loss Control Program";

    case 5:
      return value === "YES"
        ? "Advanced Hair Restoration Protocol"
        : 6;

    case 6:
      return "Clinical Hair Recovery Program";

    case 7:
      return value === "YES" ? 8 : 9;

    case 8:
      return value === "YES"
        ? 9
        : "Advanced Hair Restoration Protocol (Stabilise first)";

    case 9:
      return value === "YES" ? 10 : "Transplant not advised now";

    case 10:
      return formData.gender?.toLowerCase() === "male"
        ? "Male QHT FUE Hair Transplant"
        : 11;

    case 11:
      return value === "YES"
        ? "Female transplant usually not advised"
        : "Female QHT FUE Hair Transplant";

    default:
      return null;
  }
};
const getNextStep = (step, value) => {
  switch (step) {
    case 1:
      return value == "Yes" ? 7 : 2;

    case 2:
      return value == "Yes" ? 3 : 4;

    case 3:
      return value == "Yes" ? " Clinical Hair Loss Control Program" : 4;

    case 4:
      return value == "Yes" ? 5 : "Clinical Hair Loss Control Program";

    case 5:
      return value == "Yes"
        ? "Advanced Hair Restoration Protocol"
        : 6;

    case 6:
      return "Clinical Hair Recovery Program";

    case 7:
      return value == "Yes" ? 8 : 9;

    case 8:
      return value == "Yes"
        ? 9
        : " Advanced Hair Restoration Protocol (stabilise first; transplant deferred)";

    case 9:
      return value == "Yes" ? 10 : "Transplant not advised now";

    case 10:
      return value == "Male" ? 12 : 11;

    case 11:
      return value == "Yes" ? "Advanced Hair Restoration Protocol (female transplant usually not advised)" : 13;

    case 12:
      return "Male QHT FUE Hair Transplant ";

    case 13:
      return value == "Stage 4 (usually not advised)" ? "Female Stage Based Treatment Plan" : "Female QHT FUE Hair Transplant ";

    default:
      return null;
  }
};

const handleAnswer = (step, value) => {
  const updatedAnswers = { ...answer, [step]: value };
  setAnswer(updatedAnswers);

  // Remove all steps after this step
  const currentIndex = steps.indexOf(step);
  const newSteps = steps.slice(0, currentIndex + 1);

  const next = getNextStep(step, value, formData);

  if (typeof next === "number") {
    newSteps.push(next);
    setRecommendation(null);
  } else {
    setRecommendation(next);
  }

  setSteps(newSteps);
};

  const renderQuestion1 = () => {
    const currentQuestion = questions.find(
      (q) => q.q_id === steps
    );

    if (!currentQuestion) return <p>Loading...</p>;

    return (
      <>
        <h5 className="mb-3">{currentQuestion.question}</h5>

        <Button onClick={() => handleAnswer("YES")}>
          Yes
        </Button>

        <Button
          className="ms-2"
          variant="secondary"
          onClick={() => handleAnswer("NO")}
        >
          No
        </Button>
      </>
    );
  };

  const renderQuestion = () => {
  return steps.map((stepId,index) => {
    const q = questions.find((q) => q.q_id === stepId);
    if (!q) return null;

    return (
      <div key={stepId} className="mb-4">
        <h5>{index + 1}. {q.question}</h5>

        {/* <Button
          variant={answer[stepId] === "YES" ? "primary" : "outline-primary"}
          onClick={() => handleAnswer(stepId, "YES")}
        >
          Yes
        </Button>

        <Button
          className="ms-2"
          variant={answer[stepId] === "NO" ? "secondary" : "outline-secondary"}
          onClick={() => handleAnswer(stepId, "NO")}
        >
          No
        </Button> */}
        {q.options.map((option, index) => (
          <Button
            key={index}
            className="me-2 mt-2"
            variant={
              answer[stepId] === option
                ? "primary"
                : "outline-primary"
            }
            onClick={() => handleAnswer(stepId, option)}
          >
            {option}
          </Button>
        ))}
      </div>
    );
  });
};
const generatePremiumPDF = () => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  let y = 20;

  // ===== HEADER =====
  doc.setFillColor(255, 0, 0); // Red header
  doc.rect(0, 0, pageWidth, 30, "F");

  doc.setTextColor(255, 255, 255);
  doc.setFontSize(18);
  doc.setFont("helvetica", "bold");
  doc.text("Hair Consultation Report", pageWidth / 2, 18, {
    align: "center",
  });

  doc.setTextColor(0, 0, 0);
  y = 40;

  // ===== PATIENT INFO CARD =====
  doc.setDrawColor(220, 220, 220);
  doc.setFillColor(245, 245, 245);
  doc.roundedRect(10, y, pageWidth - 20, 35, 3, 3, "FD");

  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.text("Patient Details", 15, y + 8);

  doc.setFont("helvetica", "normal");
  doc.text(`Name: ${formData.name}`, 15, y + 16);
  doc.text(`Age: ${formData.age}`, 80, y + 16);
  doc.text(`Gender: ${formData.gender}`, 15, y + 24);
  doc.text(`Mobile: ${formData.mobileno}`, 80, y + 24);

  y += 50;

  // ===== QUESTIONS SECTION =====
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("Consultation Summary", 10, y);
  y += 10;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);

  steps.forEach((stepId, index) => {
    const q = questions.find((q) => q.q_id === stepId);
    if (!q) return;

    const answers = answer[stepId] || "-";

    const questionLines = doc.splitTextToSize(
      `${index + 1}. ${q.question}`,
      pageWidth - 30
    );

    doc.text(questionLines, 15, y);
    y += questionLines.length * 6;

    doc.setFont("helvetica", "bold");
    doc.text(`Answer: ${answers}`, 20, y);
    doc.setFont("helvetica", "normal");

    y += 10;

    // Auto page break
    if (y > pageHeight - 40) {
      doc.addPage();
      y = 20;
    }
  });

  // ===== RECOMMENDATION BOX =====
  if (recommendation) {
    if (y > pageHeight - 50) {
      doc.addPage();
      y = 20;
    }

    doc.setFillColor(232, 245, 233); // Light green
    doc.roundedRect(10, y, pageWidth - 20, 25, 3, 3, "F");

    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.text("Doctor Recommendation", 15, y + 8);

    doc.setFont("helvetica", "normal");
    const recLines = doc.splitTextToSize(
      recommendation,
      pageWidth - 30
    );
    doc.text(recLines, 15, y + 16);
  }

  // ===== FOOTER =====
  doc.setFontSize(9);
  doc.setTextColor(120);
  doc.text(
    "Confidential Medical Report • Generated by Dr. Paul's Clinic",
    pageWidth / 2,
    pageHeight - 10,
    { align: "center" }
  );

  doc.save(formData.name+"-Hair-Consultation-Report.pdf");
  setIsRerenderOnData((prev) => !prev);
  handleClose();
};

  return (
    <div>
      <Button variant="primary" onClick={handleShow} style={{
        float: 'right',
        margin: '10px'
      }}>
        Start New Assessment
      </Button>

      <Modal show={showPopup} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Enter Client Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* {step === 0 ? ( */}
         {/* {step ? (
 */}
            
            <Form onSubmit={handleFormSubmit}>
             <Row className="align-items-end">
        <Col>
          <Form.Group>
            <Form.Label>Name</Form.Label>
            <Form.Control
              value={formData.name}
              isInvalid={!!errors.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
            />
            <Form.Control.Feedback type="invalid">
              {errors.name}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col>
          <Form.Group>
            <Form.Label>Age</Form.Label>
            <Form.Control
              type="number"
              value={formData.age}
              isInvalid={!!errors.age}
              onChange={(e) =>
                setFormData({ ...formData, age: e.target.value })
              }
            />
            <Form.Control.Feedback type="invalid">
              {errors.age}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col>
          <Form.Group>
            <Form.Label>Gender</Form.Label>
            <Form.Select
              value={formData.gender}
              isInvalid={!!errors.gender}
              onChange={(e) =>
                setFormData({ ...formData, gender: e.target.value })
              }
            >
              <option value="">Select</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {errors.gender}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col>
          <Form.Group>
            <Form.Label>Mobile</Form.Label>
            <Form.Control
              value={formData.mobileno}
              isInvalid={!!errors.mobileno}
              maxLength={10}
              inputMode="numeric"
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, ""); // remove non-digits
    setFormData({ ...formData, mobileno: value });
  }}
            />
            <Form.Control.Feedback type="invalid">
              {errors.mobileno}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        {/* <Col xs="auto">
          <Button type="submit">Continue</Button>
        </Col> */}
      </Row>
              <Row className="mt-4">
                              {renderQuestion()}

                </Row>
            </Form>
          {/* ) :  */}
          {recommendation ? (
            <>
              <h4 className="text-success mb-3">
                Recommended Program:
              </h4>
              <h5>{recommendation}</h5>

              <Button
                className="mt-3"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? "Saving..." : "Save & Download PDF"}
              </Button>
            </>
          ) : null
          }

        </Modal.Body>
      </Modal>

      <CRUDTable
        API={API("programquestion")}
        idExtractor={(data) => data.q_id}
        tableName="Treatment Recommendation"
        hideEditButton
        hideDeleteButton
        hideAddButton
        isRerenderOnDataChange={isRerenderOnData}
        config={{
          columns: [
            // { label: "SL", db_name: "q_id" },
            { label: "Name", db_name: "name" },
            { label: "Age", db_name: "age" },
            { label: "Gender", db_name: "gender" },
            { label: "Mobile", db_name: "mobileno" },
            { label: "Question", db_name: "question" },
            { label: "Answer", db_name: "answer" },
            { label: "Recommendation", db_name: "recommendation" },
          ],
        }}
      />
    </div>
  );
};


export default ProgramQuestions;
